import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import clsx from "clsx";
import {Link, useLocation} from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    menu: {

        overflow: 'hidden',

        '& > *:first-child': {
            borderLeftWidth: 0,
        },
        '& > *:last-child': {

        }
    },
    menuItem: {
        color: theme.palette.success.main,
        borderWidth: 0,
        borderRadius: 4,
        fontWeight: 'bold',
        padding: theme.spacing(1,0),
        transition: 'all 0.3s',
        '&:hover': {
            backgroundColor: theme.palette.success.light,
            color: 'white',
            cursor: 'pointer',
            fontWeight: 'bold'
        },
        '&.active': {
            backgroundColor: theme.palette.success.light,
            color: 'white',
            cursor: 'pointer',
            fontWeight: 'bold'
        }
    },

}));

export default function SimpleTabMenu(props){

    const classes = useStyles();

    const {menu} = props;

    const location = useLocation()


    return (
        <div className={clsx([
            'row my-4 mx-2',
            classes.menu
        ])}>

            {
                menu.map(
                    menuItem => {

                        return (
                            <Link
                                to={menuItem.to}
                                className={clsx([
                                    classes.menuItem,
                                    'col text-center',
                                    {
                                        ['active']: location.pathname == menuItem.to
                                    }
                                ])}>
                                {menuItem.label}
                            </Link>
                        )
                    }
                )
            }

        </div>
    )

}